var chunkToChildrenMap = {
	"55": [
		722,
		862,
		680
	],
	"70": [
		722,
		862,
		680
	],
	"273": [
		722,
		862,
		680
	],
	"285": [
		722,
		862,
		680
	],
	"299": [
		722,
		862,
		680
	],
	"595": [
		722,
		862,
		680
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));